<template>
  <div class="flex flex-col items-center space-y-3.5 sm:px-0 px-5 w-full">
    <div
      class="size-24 min-w-24 rounded-full bg-gray-100 text-black flex items-center justify-center"
    >
      <slot name="icon"></slot>
    </div>
    <h2 class="text-center" v-if="title">{{ title }}</h2>
    <p class="text-center text-sm text-gray-500" v-if="description">
      {{ description }}
    </p>
    <BaseButton
      class="rounded-lg md:w-80 w-full"
      @click="$emit('click')"
      v-if="action"
      :label="label"
    ></BaseButton>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits(["click"]);

withDefaults(
  defineProps<{
    label?: string;
    title?: string;
    description?: string;
    action?: boolean;
  }>(),
  {
    title: "",
    description: "",
    label: "",
    action: false,
  },
);
</script>
